export class AppSettings {

    public static NAME    = "Paraty Tours";
    public static PREFIXO = "paraty"; 

}